/* eslint-disable camelcase */

import get from 'lodash/get';
import find from 'lodash/find';
import {
    configKeys,
    configOptions,
    gapCostOptionsByAlgorithm,
    shortAlgorithmConfig,
} from '../constants/constantConfig';
import { SEARCH_TYPE } from '../constants';
import { shortDefaultAlgorithms } from '../constants/defaultSettings';

export default {
    computed: {
        algorithm() {
            return this.settingValues.algorithm;
        },
        algorithmOptions() {
            return get(configOptions, [this.configOptionsType, 'algorithmOptions'], []);
        },
        algorithmOption() {
            return find(this.algorithmOptions, { value: this.settingValues.algorithm });
        },
        crossType() {
            return this.configOptionsType === configKeys.nucTypeProtDbConfigs
                || this.configOptionsType === configKeys.protTypeNucDbConfigs;
        },
        algorithmSettingsDisabled() {
            // this.isMultiDbType
            return !this.settingValues.sequenceType || (this.settingValues.dbType || []).length !== 1;
        },
        defaultAlgorithm() {
            return this.settingValues.automatic;
        },
        matrixOptions() {
            return get(this.algorithmOption, ['children', 'matrix'], []);
        },
        wordSizeOptions() {
            if (this.searchType === SEARCH_TYPE.short) {
                return shortAlgorithmConfig[this.configOptionsType]?.word_size || [];
            }
            return get(this.algorithmOption, ['children', 'word_size'], []);
        },
        matchScoresOptions() {
            return get(this.algorithmOption, ['children', 'match_scores'], []);
        },
        gapCostsOptions() {
            const { algorithm, match_scores, matrix } = this.settingValues;
            if (this.configOptionsType === configKeys.nucTypeNucDbConfigs) {
                return get(gapCostOptionsByAlgorithm, [algorithm, match_scores], []);
            }
            return get(gapCostOptionsByAlgorithm, [algorithm, matrix], []);
        },
    },
    watch: {
        configOptionsType: {
            handler() {
                // 守卫必须在同步阶段(微任务)判断：assignValues 用 setTimeout(宏任务)复位 isInitValues，
                // 若把判断放进 setTimeout 内，会排在复位之后执行而漏判，导致初始化还原时算法值被错误回落。
                if (!this.isInitValues) {
                    setTimeout(() => {
                        this.afterChangeType(true);
                    }, 0);
                }
            },
        },
        isMultiDbType: {
            handler(to, from) {
                // 同上：isInitValues 守卫在同步阶段判断；to/from 在此同步作用域可得。
                if (!to && from && !this.isInitValues) {
                    setTimeout(() => {
                        this.afterChangeType(true);
                    }, 0);
                }
            },
        },
        // settingValues: {
        //     handler(to, from) {
        //         if (to !== from && !this.isInitValues) {
        //             this.afterChangeType();
        //         }
        //     },
        // },m
    },
    methods: {
        // xxx 算法中有联动的逻辑，需要在设置算法后检查有没有正确的值，或者受其他设置影响导致选项的值不可用了，需要给默认值
        afterChangeType(setToDefault = false) {
            if (this.crossType && this.settingValues.automatic) {
                this.$set(this.settingValues, 'automatic', false);
                this.writeFieldValue('automatic');
            }
            let currentAlgorithm = this.algorithmOption;
            if (!currentAlgorithm) {
                currentAlgorithm = this.algorithmOptions.find((x) => {
                    if (this.searchType === SEARCH_TYPE.short) {
                        return shortDefaultAlgorithms.includes(x.value);
                    }
                    return x.default;
                });
            }
            if (this.settingValues.algorithm !== currentAlgorithm?.value) {
                this.$set(this.settingValues, 'algorithm', currentAlgorithm?.value);
                this.writeFieldValue('algorithm');
            }
            this.afterSetAlgorithmFields(setToDefault);
        },
        afterSetAlgorithmFields(setToDefault = false) {
            const algorithmOptions = get(configOptions, [this.configOptionsType, 'algorithmOptions'], []);
            const currentAlgorithm = algorithmOptions.find((x) => x.value === this.settingValues.algorithm);

            if (currentAlgorithm?.value) {
                const { matrix, word_size, match_scores } = currentAlgorithm.children || {};
                if (matrix) {
                    let currentMatrix = this.settingValues.matrix;
                    if (!currentMatrix || setToDefault) {
                        currentMatrix = matrix.find((x) => x.default)?.value;
                    }
                    if (this.settingValues.matrix !== currentMatrix) {
                        this.$set(this.settingValues, 'matrix', currentMatrix);
                        this.writeFieldValue('matrix');
                    }
                }

                if (word_size) {
                    let currentWordSize = this.settingValues.word_size;
                    let word_size_options = word_size;
                    if (this.searchType === SEARCH_TYPE.short) {
                        word_size_options = shortAlgorithmConfig[this.configOptionsType]?.word_size || [];
                    }
                    if (!currentWordSize || setToDefault) {
                        currentWordSize = word_size_options.find((x) => x.default)?.value;
                    }
                    if (this.settingValues.word_size !== currentWordSize) {
                        this.$set(this.settingValues, 'word_size', currentWordSize);
                        this.writeFieldValue('word_size');
                    }
                }

                if (match_scores) {
                    let currentMatchScores = this.settingValues.match_scores;
                    if (!currentMatchScores || setToDefault) {
                        currentMatchScores = match_scores.find((x) => x.default)?.value;
                    }
                    if (this.settingValues.match_scores !== currentMatchScores) {
                        this.$set(this.settingValues, 'match_scores', currentMatchScores);
                        this.writeFieldValue('match_scores');
                    }
                }

                let currentGaps = this.settingValues.gaps;
                if (!currentGaps || setToDefault) {
                    currentGaps = this.gapCostsOptions.find((x) => x.default || x.isDefault)?.value;
                }
                if (this.settingValues.gaps !== currentGaps) {
                    this.$set(this.settingValues, 'gaps', currentGaps);
                    this.writeFieldValue('gaps');
                }
            }
        },
    },
};
